import { useState } from 'react';
import { api } from '../lib/api.js';
import { Field } from './Field.jsx';
import { inputStyle } from '../lib/ui.js';

export function TORReviewModal({ modal, currentUser, onClose, onDone }) {
  const { tor, action } = modal;
  const isLate = !!tor.is_late;
  const [managerNote, setManagerNote] = useState('');
  const [overrideLate, setOverrideLate] = useState(false);
  // No overrideReason state any more — approving never asks for typed
  // justification. The server stamps the audit row "approved past deadline".
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  // Deny needs a reason; approve never does. The server enforces this too —
  // this only stops the manager submitting an empty deny and bouncing off a
  // 400 they'd have to read to understand.
  const needsReason = action === 'deny' && !managerNote.trim();

  async function go() {
    setBusy(true); setErr('');
    try {
      const path = action === 'approve' ? `/api/tor/${tor.id}/approve` : `/api/tor/${tor.id}/deny`;
      const body = action === 'approve'
        ? { manager_note: managerNote || null, override_late: overrideLate, late_override_reason: null }
        : { manager_note: managerNote || null };
      await api('PUT', path, body, { 'x-user-id': String(currentUser.id) });
      onDone();
    } catch (e) {
      let msg = e.message || 'Failed';
      try { const p = JSON.parse(msg); msg = p.error + (p.current != null ? ` (have ${p.current}h, requested ${p.requested}h)` : ''); } catch {}
      setErr(msg);
    }
    finally { setBusy(false); }
  }

  return (
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000,
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 10, padding: 20, maxWidth: 460, width: '100%' }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>
          {action === 'approve' ? 'Approve' : 'Deny'} time off request
        </div>
        <div style={{ fontSize: 13, color: '#37474f', marginBottom: 12 }}>
          <div><strong>{tor.employee_name}</strong> · {tor.employee_role}</div>
          <div>
            {tor.requested_date_start === tor.requested_date_end
              ? tor.requested_date_start
              : `${tor.requested_date_start} → ${tor.requested_date_end}`}
            {tor.requested_time_start && tor.requested_time_end &&
              ` · ${tor.requested_time_start}–${tor.requested_time_end}`}
          </div>
          {tor.use_pto ? <div style={{ color: '#1565c0', fontSize: 12, marginTop: 2 }}>Will deduct {tor.pto_hours}h from PTO on approve.</div> : null}
          {tor.reason && <div style={{ fontSize: 12, color: '#757575', marginTop: 2 }}>"{tor.reason}"</div>}
        </div>
        {action === 'approve' && isLate && (
          <div style={{ padding: 10, background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 6, marginBottom: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#a16207', marginBottom: 6 }}>Late submission</div>
            <div style={{ fontSize: 11, color: '#5d4037', marginBottom: 6 }}>
              Deadline was {tor.deadline_at?.slice(0, 10)}. Approving past the deadline will be logged in the override audit.
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
              <input type="checkbox" checked={overrideLate}
                onChange={(e) => setOverrideLate(e.target.checked)} />
              Override the deadline
            </label>
            {/* CJ 2026-08-02: approving must never ask the manager to type
                a justification. The override is still written to the
                policy-override audit — the server records it as
                "approved past deadline" — so the trail survives without
                the friction. The tick stays because it is an explicit
                acknowledgement, not a reason. */}
          </div>
        )}
        <Field label={action === 'approve' ? 'Manager note (optional)' : 'Reason for denial (required)'}>
          <input value={managerNote} onChange={(e) => setManagerNote(e.target.value)}
            placeholder={action === 'approve' ? '' : 'The staff member sees this'}
            style={inputStyle} />
        </Field>
        {err && <div style={{ fontSize: 11, color: '#c62828', marginTop: 6 }}>{err}</div>}
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose} className="btn-secondary" style={{ fontSize: 12 }}>Cancel</button>
          <button onClick={go} disabled={busy || needsReason}
            style={{ background: action === 'approve' ? '#2e7d32' : '#c62828',
                      color: '#fff', border: 'none', borderRadius: 6,
                      padding: '6px 16px', fontSize: 13, fontWeight: 600,
                      cursor: (busy || needsReason) ? 'not-allowed' : 'pointer',
                      opacity: (busy || needsReason) ? 0.5 : 1 }}
            title={needsReason ? 'Enter a reason for the denial' : undefined}>
            {busy ? '…' : (action === 'approve' ? 'Approve' : 'Deny')}
          </button>
        </div>
      </div>
    </div>
  );
}
